import { Button } from "antd";
import { useForm } from "react-hook-form";
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { TPIService } from '../../base/tpiService';
import { initialStateModel } from "../../models/model";
import styles from "../privateapp/scss/privateapp.module.scss";
import { toastInformation } from '../../base/callService/common';
import { URCheckBoxCall } from '../../shared/widgets/checkBoxForCall/callCheckBox';

type PrivateAppData = {
  name: string,
  logo: string,
  description: string,
  selectedscope: Array<any>,
  scopeList: Array<any>,
  appId: string;
}

type PrivateAppCreProps = {
  closeModal: Function,
  selectedApp: any;
}

export const PrivateAppEdit = ({ closeModal, selectedApp }: PrivateAppCreProps) => {
  const { loginReducer }: initialStateModel = useSelector(
    (state: initialStateModel) => state
  );

  const { register, setValue, getValues, setError, clearErrors, handleSubmit, formState: { errors } } = useForm();
  const selectedApp_copy = { ...selectedApp };
  const [currentStep, setCurrentStep] = useState(1);
  const [getPrivateAppData, setPrivateAppData] = useState<PrivateAppData>({
    name: selectedApp_copy.name || "",
    logo: selectedApp_copy.logo,
    description: selectedApp_copy.description || "",
    selectedscope: selectedApp_copy.scopeID || [],
    scopeList: [],
    appId: selectedApp_copy.appId || ""
  });

  const onSubmit = async (data: any) => {
    furtherStep(+1);
  }

  const getScopeList = async () => {
    let response: any = await TPIService.getUcaasScopes();
    if (response.statusCode === 200) {
      setPrivateAppData({ ...getPrivateAppData, scopeList: response.result });
    }
    else {
      console.log("err in listing scopes");
    }
  }

  const furtherStep = (move: number) => {
    setCurrentStep(currentStep + move)
  }

  // const checkConnectButton = () => {
  //   let isChecked = false;
  //   if (currentStep === 2 && getPrivateAppData.selectedscope.length > 0) {
  //     isChecked = true
  //   }
  //   return isChecked;
  // }

  const checkConnectButton = () => {
    let scopeLength = getPrivateAppData.selectedscope.length === 0;
    // console.log("err in listing scopes",scopeLength);
    console.log("err in listing scopes1",getPrivateAppData.description?.trim() === selectedApp_copy.description?.trim());
    console.log("err in listing scopes2", getPrivateAppData.name?.trim() === selectedApp_copy.name?.trim());
    console.log("err in listing scopes3", getPrivateAppData.selectedscope?.sort()?.toString() === selectedApp_copy.scopeID?.sort()?.toString());
    if (
      (scopeLength || getPrivateAppData.description?.trim() === selectedApp.description?.trim()) &&
      (scopeLength || getPrivateAppData.name?.trim() === selectedApp.name?.trim()) &&
      (scopeLength || getPrivateAppData.selectedscope?.sort()?.toString() === selectedApp.scopeID?.sort()?.toString())
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getPrivateAppToken = async () => {
    if (currentStep !== 1) {
      const payload = {
        "domainId": loginReducer.userdetails.domain_id,
        "appName": getPrivateAppData.name,
        "description": getPrivateAppData.description,
        "logo": "",
        "scopeId": getPrivateAppData.selectedscope.toString(),
        "appId": getPrivateAppData.appId,
        "email": loginReducer.userdetails.Email,
        "productType": "ucaas",
        "sipLoginId": loginReducer.userdetails.sip_login_id,
        "ext": loginReducer.userdetails.ext
      };

      let response = await TPIService.createEditPrivateApp(payload);

      if (response.statusCode === 200) {
        closeModal();
        toastInformation('private app updated successfully', 'success');
      }
      else {
        toastInformation(response.message, 'failure');
      }
    }
  }

  const handleSelect = (scopeData: any) => {
    let tempArray = [...getPrivateAppData.selectedscope];
    let scope_Id = scopeData?.toString();
    if (tempArray.length > 0 && tempArray.includes(scope_Id.toString())) {
      tempArray = tempArray.filter((elem) => elem !== scope_Id);
    } else {
      tempArray.push(scope_Id);
    }
    setPrivateAppData({ ...getPrivateAppData, selectedscope: tempArray });
  }


  useEffect(() => {
    getScopeList();
  }, []);


  return (
    <div className=" popupmodal">
      <div className="popupmodalblock">

        <div>
          <div className="privateappcustomtab">
            <div className="header">
              <h5> Edit your Private App</h5>
              <svg onClick={() => { closeModal() }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M9.20074 8.00101L15.0557 2.14551C15.3877 1.81441 15.3877 1.27541 15.0557 0.944312C14.7237 0.612312 14.1846 0.612312 13.8545 0.944312L7.99954 6.79971L2.14454 0.944312C1.81444 0.612312 1.27344 0.612312 0.943336 0.944312C0.611336 1.27541 0.611336 1.81441 0.943336 2.14551L6.79834 8.00101L0.943336 13.8565C0.611336 14.1876 0.611336 14.7266 0.943336 15.0577C1.10934 15.2237 1.32614 15.3067 1.54394 15.3067C1.76174 15.3067 1.97944 15.2237 2.14454 15.0577L7.99954 9.20231L13.8545 15.0577C14.0195 15.2237 14.2373 15.3067 14.4551 15.3067C14.6729 15.3067 14.8897 15.2237 15.0557 15.0577C15.3877 14.7266 15.3877 14.1876 15.0557 13.8565L9.20074 8.00101Z" fill="#757676" />
              </svg>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div>
                <div className="privatecustormmodalbody">
                  <div className={styles.stepperpersonaldtlsbodyy}>
                    <div className={styles.topsteps}>
                      <div className={styles.maincontainer}>
                        <ul>
                          <li className={currentStep === 2 ? `${styles.residentDetails} ${styles.active}` : styles.residentDetails}>
                            <span>1</span>App Info
                          </li>
                          <li className={styles.residentDetails}>
                            <span>2</span>scope
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {
                    currentStep === 1 && <div className={styles.stepperinputbdy}>
                      <div className={styles.createformblock}>
                        <label>
                          Name <span>*</span>
                        </label>

                        <input
                          placeholder="Enter name"
                          className="heightcorectioninput"
                          autoFocus={true}
                          {...register("name", {
                            required: "App Name required",

                            maxLength: {
                              value: 30,
                              message: "Maximum 30 characters only accepted"
                            },
                            minLength: {
                              value: 3,
                              message: "Enter a name with at least 3 characters"
                            },
                            pattern: {
                              value: /^[A-Za-z]+(\s+[A-Za-z]+)*$/,
                              message: "Invalid name. Review requirements and try again."
                            }

                          })}
                          onChange={(e: any) =>
                            setPrivateAppData({
                              ...getPrivateAppData, name: e.target.value
                            })}
                          value={getPrivateAppData?.name}
                        />
                      </div>
                      {errors.name && <p className={styles.errormsg}> {errors.name.message}</p>}

                      <div className={styles.createformblock}>
                        <label>
                          Description<span>*</span>
                        </label>
                        <textarea
                          // name="description"
                          placeholder="Enter a Description"
                          {
                          ...register("description", {
                            required: "please enter the Description",
                            minLength: {
                              value: 10,
                              message: 'Enter a Description'
                            },
                            maxLength :{
                              value : 45,
                              message : 'Maximum Character 45 character'
                            },  
                            pattern: {
                              value: /^[A-Za-z]+(\s+[A-Za-z]+)*$/,
                              message: "Invalid Description. Review requirements and try again."
                            }
                          })
                          }
                          onChange={(e: any) =>
                            setPrivateAppData({
                              ...getPrivateAppData,
                              description: e.target.value
                            })}
                          value={getPrivateAppData?.description}
                        />
                      </div>
                      {errors.description && <p className={styles.errormsg} >{errors.description.message}</p>}
                    </div>
                  }

                  {currentStep === 2 &&
                    <div>
                      <div className={styles.checklistsection}>
                        {
                          getPrivateAppData.scopeList.map((scopeData: any, index: any) => {
                            return (
                              <div key={index} className={styles.checklistrow}>
                                <div className={styles.checklisttext}>
                                  <p>{scopeData.scopeTitle.concat(".", scopeData.scope)}</p>
                                </div>
                                <div className={styles.checkboxflexcon}>
                                  <URCheckBoxCall
                                    onChange={(e: any) => { handleSelect(scopeData.scopeId) }} checked={getPrivateAppData.selectedscope?.includes(scopeData.scopeId.toString())} />
                                </div>
                              </div>
                            )
                          })
                        }
                       
                      </div>
                      <div className='privatecustormmodalfooter'>
                        <div className={styles.footerbottomnew}>
                          <div className={styles.footerbottomnewbtnsec}>
                            <Button key="cancel" className={styles.secondarybutton} onClick={() => { furtherStep(-1) }}>Back</Button>
                            <Button className={checkConnectButton() ? `${styles.primarybutton} ${styles.disabled}` : styles.primarybutton} onClick={getPrivateAppToken}>Update</Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>

                {currentStep === 1 && <div className="privatecustormmodalfooter">
                  <div className={styles.footerbottomnew}>
                    <div className={styles.footerbottomnewbtnsec}>
                      <Button key="cancel" onClick={() => { closeModal() }} className={styles.secondarybutton}>Cancel</Button>
                      <button key="trim" className={styles.primarybutton}>Next</button>
                    </div>

                  </div>
                </div>
                }
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}